exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#access {\n  padding: 7px;\n  margin-top: 16px;\n  font-size: 1.24em;\n}\n#access .gradient-background {\n    color: white;\n    background: #cbe2c1;\n    background: -webkit-gradient(linear, left top, right top, from(#0f6aab), to(#529ee4e6));\n    background: linear-gradient(to right, #0f6aab, #529ee4e6);\n    padding: 40px 20px;\n}\n#access .row div {\n    margin-top: 4px;\n}\n#access h5 {\n    font-size: 1.03em;\n}\n#access .section-title {\n    margin-top: 20px;\n}\n#access .section-title h5 {\n      margin-bottom: 4px;\n}\n@media screen and (max-width: 660px) {\n#access .section-title div {\n        padding-left: 8px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a83f80c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/pages/access/access.component.scss
// module id = 227
// module chunks = 1